import React, { useState } from "react";

const faqData = [
  {
    question: "How does FilingIQ protect my data?",
    answer:
      "Absolutely. All documents are encrypted at rest and in transit. Your data is never sold or shared.",
  },
  {
    question: "Is this for any firm size?",
    answer:
      "Yes, FilingIQ supports solo CPAs to multi-partner practices.",
  },
  {
    question: "What if I see that the classification is wrong?",
    answer:
      "Our app provides the ability for accountants or any staff to manually override any classification they see is incorrect.",
  },
  {
    question: "Does FilingIQ work with QuickBooks or other accounting software?",
    answer:
      "Integrations are on our roadmap! Join the waitlist to get updates and help us prioritize features.",
  },
];

export default function IndexSectionHowItWorksLightReverse6() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faqs" className="py-10 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="py-16 px-8 bg-gray-100 overflow-hidden rounded-3xl">
          <div className="mb-10 md:max-w-xl mx-auto text-center">
            <span className="inline-block mb-5 text-sm text-blue-500 font-bold uppercase tracking-widest">
              Frequently asked questions
            </span>
            <h2 className="font-heading mb-6 text-4xl md:text-5xl lg:text-6xl text-gray-900 font-black tracking-tight">
              Got questions? We’re here to help!
            </h2>
            <p className="text-gray-500 font-bold">
              Here's FilingIQ's answers to your most common concerns
            </p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="flex flex-wrap -m-3 mb-10">
              {faqData.map((faq, i) => (
                <div className="w-full p-3" key={i}>
                  <button
                    className="block w-full text-left p-10 bg-white rounded-3xl cursor-pointer shadow transition"
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    aria-expanded={openIndex === i}
                  >
                    <div className="flex flex-wrap -m-2 items-center">
                      <div className="flex-1 p-2">
                        <h3 className="font-heading text-xl text-gray-900 font-black">
                          {faq.question}
                        </h3>
                        <div
                          className={`overflow-hidden transition-all duration-500 ${
                            openIndex === i ? "max-h-40 mt-4" : "max-h-0"
                          }`}
                          style={{
                            // Height animation is smoother with maxHeight, or you can use auto with a lib
                            // Here, 160px (40 * 4) is an example for a 2-3 line answer.
                            // Adjust as needed, or use an animation library for auto height
                          }}
                        >
                          <p className="text-gray-500 font-bold">{openIndex === i && faq.answer}</p>
                        </div>
                      </div>
                      <div className="w-auto p-2">
                        <span
                          className={`inline-block transform transition-transform duration-300 ${
                            openIndex === i ? "rotate-180" : "rotate-0"
                          }`}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.9207 8.17999H11.6907H6.08072C5.12072 8.17999 4.64073 9.33999 5.32073 10.02L10.5007 15.2C11.3307 16.03 12.6807 16.03 13.5107 15.2L15.4807 13.23L18.6907 10.02C19.3607 9.33999 18.8807 8.17999 17.9207 8.17999Z"
                              fill="#D1D5DB"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              ))}
            </div>
            <p className="text-gray-500 font-bold text-center">
              <span>Still have any questions? </span>
<a
  className="text-blue-500 hover:text-blue-600"
  href="chris@filing-iq.com"
>
  Contact us
</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
